// extracted by mini-css-extract-plugin
module.exports = {"elSection":"Section_elSection__3SKz5","cardSection":"Section_cardSection__2nUfJ","elForm":"Section_elForm__DqUYa","securityField1":"Section_securityField1__2nk0_"};